// replace {newLine} with 1 line break
// replace {newParagraph} with 2 line breaks
function replaceToken(token) {
    return token
        .replace(/{newLine}/g, '<br />')
        .replace(/{newParagraph}/g, '\n\n');
}

export default {
    name: 'newLineInjector',
    process(value, key, options, translator) {
        if (typeof value !== 'string') {
            return value
                .filter(Boolean) // don't care about empty strings
                .map((token) => {
                    if (typeof token !== 'string') {
                        return token;
                    }

                    return replaceToken(token);
                });
        }

        return replaceToken(value);
    },
    type: 'postProcessor',
};
